import ApiConstants from "../../Constants/ApiConstant";
import { apiGet, apiPost } from "../../Services/ApiService";

export const UploadMediaRequestAPI = (
  selectedFiles,
  driveName,
  isMultiple,
  callBack
) => {
  let formData = new FormData();
  // Append files to FormData
  if (isMultiple) {
    selectedFiles.forEach((file) => {
      formData.append("files", file); // Ensure 'file' is a File object
    });
  } else {
    formData.append("files", selectedFiles[0]); // Ensure this is a File object
  }

  formData.append("file_drive", driveName); // Make sure the drive name is correct

  return async () => {
    try {
      await apiPost(
        `${ApiConstants.createFileStorageUrl}?file_drive=${driveName}`,
        formData,
        {
          "Content-Type": "multipart/form-data", // Ensure proper content type
        }
      )
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("Error uploading media:", err);
          callBack && callBack(false, err);
        });
    } catch (err) {
      console.log("Error in UploadMediaRequestAPI:", err);
      throw err;
    }
  };
};

export const getMediaRequestAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(ApiConstants.fileStorageUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("get dashboard details api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("get dashboard details api err:", err);
      throw err;
    }
  };
};
